import React, { useMemo } from 'react';
import { DataGrid } from '@gogame/data-grid';

import {
  useScreenDispatch,
  useScreenState,
  SET_TABLE_SETTINGS,
} from '@gogame/screens';

import { useLoadAuditLogGrid } from 'scenes/AuditLogs/data';
import { useExportTable } from 'scenes/AuditLogs/data/mutations';

import {
  COLUMN_TIME,
  COLUMN_USER,
  COLUMN_PAGE,
  COLUMN_TYPE,
  COLUMN_DETAILS,
} from 'scenes/AuditLogs/constants';
import {
  COLLAPSE_COLUMNS,
  REORDER_COLUMNS,
} from 'scenes/AuditLogs/screenReducer';
import AuditLogDataTableToolbar from './AuditLogDataTableToolbar';

const AuditLogDataTable = () => {
  const dispatch = useScreenDispatch();
  const screenState = useScreenState();

  const [exportTable] = useExportTable();
  const params = useMemo(() => {
    const { filters, tableSettings } = screenState;
    return { filters, tableSettings };
  }, [screenState]);

  const { data, isLoading, isRefetching } = useLoadAuditLogGrid(params);

  const handleExport = () => {
    const { filters, tableSettings } = screenState;
    exportTable({
      filters,
      settings: tableSettings,
    });
  };

  const handleCollapse = (collapsed) => {
    dispatch({
      type: COLLAPSE_COLUMNS,
      payload: collapsed,
    });
  };

  const handleChangeSettings = (settings) => {
    dispatch({
      type: SET_TABLE_SETTINGS,
      payload: settings,
    });
  };

  const handleReorder = (order) => {
    dispatch({
      type: REORDER_COLUMNS,
      payload: order,
    });
  };

  const getRowId = (row) => {
    return row.uniqueFakeId;
  };

  return (
    <DataGrid
      rows={data?.rows}
      count={data?.count}
      loading={isLoading}
      fetching={isRefetching}
      onChangeSettings={handleChangeSettings}
      onReorder={handleReorder}
      onCollapse={handleCollapse}
      ready={screenState.ready}
      tableSettings={screenState.tableSettings}
      columnsState={screenState.columns}
      toolbar={<AuditLogDataTableToolbar onExport={handleExport} />}
      storageKey={'audit-log'}
      defaultColumnWidth={120}
      filtered={!!screenState.searchQuery}
      getRowId={getRowId}
    >
      <DataGrid.Column
        field={COLUMN_TIME}
        type={'date'}
        template={'LLL'}
        timeZone={'utc'}
        headerName={'Time'}
        width={180}
      />
      <DataGrid.Column
        field={COLUMN_USER}
        type={'text'}
        headerName={'User'}
        width={260}
        getValue={(v) => v?.name}
      />
      <DataGrid.Column
        field={COLUMN_PAGE}
        type={'text'}
        headerName={'Page'}
        width={200}
        getValue={(v) => v?.name}
      />
      <DataGrid.Column
        field={COLUMN_TYPE}
        type={'text'}
        headerName={'Type'}
        width={260}
        getValue={(v) => v?.name}
      />
      <DataGrid.Column
        field={COLUMN_DETAILS}
        type={'text'}
        headerName={'Details'}
        minWidth={900}
        flex={1}
        getTooltip={(v) => v}
      />
    </DataGrid>
  );
};

export default AuditLogDataTable;
